import { motion } from "framer-motion";
import bitqueryLogo from "../assets/images/bitquery_logo.png";
import bitqueryLogoHover from "../assets/images/bitquery_logo_1.png";

const BitqueryLogo = () => {
  return (
    <motion.div
      className="flex flex-col items-center text-gray-500 text-sm mr-2 cursor-pointer"
      initial={{ opacity: 0.7 }}
      whileHover={{ opacity: 1, scale: 1.05 }}
      transition={{ duration: 0.3 }}
      onClick={() => window.open("https://bitquery.io/", "_blank")}
    >
      {/* Text Above */}
      <span className="mb-1 text-xs">Powered by</span>

      {/* Image Container for Hover Effect */}
      <div className="relative h-auto max-h-6 w-auto overflow-hidden">
        {/* Default Logo */}
        <motion.img
          src={bitqueryLogo}
          alt="Bitquery"
          className="h-auto max-h-6 w-auto"
          initial={{ opacity: 1 }}
          whileHover={{ opacity: 0 }}
          transition={{ duration: 0.15, ease: "easeInOut" }}
        />

        {/* Hover Logo */}
        <motion.img
          src={bitqueryLogoHover}
          alt="Bitquery Hover"
          className="h-auto max-h-6 w-auto absolute top-0 left-0"
          initial={{ opacity: 0 }}
          whileHover={{ opacity: 1 }}
          transition={{ duration: 0.15, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
};

export default BitqueryLogo;
